export const cookieEnums = {
  ACCESS_TOKEN: 'access-token',
  REFRESH_TOKEN: 'refresh-token',
  ORGANISATION: 'organisation-id',
  USER_ID: 'user-id',
  LAST_USED_SOCIAL_PROVIDER: 'last-used-oauth-provider',
} as const

export const minPasswordLength = 8
